import { useParams } from 'react-router';
import OrganizationContentStack from '../organization-content-stack';
import EventList from './event-list';
import { useActiveOrganizationStore } from '@/state/stores/use-organization-store';

export default function OrganizationEventsList() {
  const { organizationId } = useParams();
  const activeOrganization = useActiveOrganizationStore((s) => s.activeOrganization);

  if (!organizationId || !activeOrganization || organizationId !== activeOrganization.id) {
    return null;
  }

  return <OrganizationContentStack content={<EventList organizationId={organizationId} />} />;
}
